import { useQueryClient } from 'react-query';
import { 
  invalidateCalendarQueries,
  invalidatePlayerQueries,
  invalidateTeamQueries,
  invalidateLeagueQueries,
  invalidateSyncQueries,
  invalidateMatchQueries
} from '@/utils/calendarInvalidation';

/**
 * Custom hook that provides calendar invalidation functions
 * Use this hook in components that perform operations affecting the schedule
 */
export const useCalendarInvalidation = () => {
  const queryClient = useQueryClient();

  return {
    // Invalidate all calendar and schedule queries
    invalidateCalendar: () => invalidateCalendarQueries(queryClient),
    
    // Invalidate when player data changes
    invalidatePlayer: () => invalidatePlayerQueries(queryClient),
    
    // Invalidate when team assignments change
    invalidateTeam: () => invalidateTeamQueries(queryClient),
    
    // Invalidate when league data changes
    invalidateLeague: () => invalidateLeagueQueries(queryClient),
    
    // Invalidate when sync operations complete
    invalidateSync: () => invalidateSyncQueries(queryClient),
    
    // Invalidate when match data changes
    invalidateMatch: () => invalidateMatchQueries(queryClient),
    
    // Force refresh all calendar data immediately
    refetchCalendar: async () => {
      await queryClient.refetchQueries({
        predicate: (query) => {
          const key = query.queryKey;
          return Array.isArray(key) && 
                 (key[0] === 'schedule-calendar' || 
                  key[0] === 'conflicts-calendar' ||
                  key[0] === 'dashboard-schedule');
        }
      });
    },
    
    // Get the query client for custom invalidation patterns
    queryClient
  };
};
